import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconRegex = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M16.8571 4C16.8571 3.58579 16.5213 3.25 16.1071 3.25C15.6929 3.25 15.3571 3.58579 15.3571 4V7.20098L12.585 5.6005C12.2263 5.39339 11.7676 5.5163 11.5605 5.87502C11.3534 6.23374 11.4763 6.69243 11.835 6.89954L14.6071 8.50002L11.835 10.1005C11.4763 10.3076 11.3534 10.7663 11.5605 11.125C11.7676 11.4837 12.2263 11.6066 12.585 11.3995L15.3571 9.79906V13C15.3571 13.4142 15.6929 13.75 16.1071 13.75C16.5213 13.75 16.8571 13.4142 16.8571 13V9.79905L19.6292 11.3995C19.9879 11.6066 20.4466 11.4837 20.6537 11.125C20.8608 10.7663 20.7379 10.3076 20.3792 10.1005L17.6071 8.50002L20.3792 6.89954C20.7379 6.69243 20.8608 6.23374 20.6537 5.87502C20.4466 5.5163 19.9879 5.39339 19.6292 5.6005L16.8571 7.20098V4Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4.99998 20.5C5.82841 20.5 6.49998 19.8284 6.49998 19C6.49998 18.1716 5.82841 17.5 4.99998 17.5C4.17156 17.5 3.49998 18.1716 3.49998 19C3.49998 19.8284 4.17156 20.5 4.99998 20.5Z",
		fill: "currentColor"
	})]
});
export { SvgIconRegex as ReactComponent };
